import React from "react";
import { Row, Col } from "react-bootstrap";
import PCM from "./PCM";
import './SubjectCards.css';
import PCB from "./PCB";
import Commerce from "./Commerce";
import Humanities from "./Humanities";

const SubjectCards = () => {
  return (
    <div className="subject_cards">
      <Col>
        <Row>
          <Col className="columnn">
            <PCM />
          </Col>
          <Col className="columnn">
            <PCB />
          </Col>
        </Row>
        <Row style={{ marginTop: "2rem" }}>
          <Col className="columnn">
            <Commerce />
          </Col>
          <Col className="columnn">
            <Humanities />
          </Col>
        </Row>
      </Col>
    </div>
  );
};

export default SubjectCards;
